module.exports = __webpack_public_path__ + "static/contact_bg-08fa89408eba374f4c8bda0dea55aba8.jpg";